import { AxiosResponse } from 'axios';

import { getRecordingSeasonsUrl } from 'config/api.ts';

import {
    RecordingsSeasonsResponse,
    ResponseError,
} from 'store/railsBuilder/reducer.types.ts';

import NagraInstance from 'utils/axios/nagra/DefaultInstance.ts';

function requestRecordingSeasons(
    seriesId: string,
): Promise<AxiosResponse<RecordingsSeasonsResponse | ResponseError>> {
    return NagraInstance.get<RecordingsSeasonsResponse>(
        getRecordingSeasonsUrl(seriesId),
    );
}

export default requestRecordingSeasons;
